'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.queryCount = exports.lastUpdated = exports.status = exports.isPending = exports.isFinished = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _queryKey = require('../lib/query-key');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFinished = exports.isFinished = function isFinished(queriesState, queryConfig) {
    if (queryConfig) {
        var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

        return (0, _lodash2.default)(queriesState, [queryKey, 'isFinished']);
    }
};

var isPending = exports.isPending = function isPending(queriesState, queryConfig) {
    if (queryConfig) {
        var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

        return (0, _lodash2.default)(queriesState, [queryKey, 'isPending']);
    }
};

var status = exports.status = function status(queriesState, queryConfig) {
    if (queryConfig) {
        var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

        return (0, _lodash2.default)(queriesState, [queryKey, 'status']);
    }
};

var lastUpdated = exports.lastUpdated = function lastUpdated(queriesState, queryConfig) {
    if (queryConfig) {
        var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

        return (0, _lodash2.default)(queriesState, [queryKey, 'lastUpdated']);
    }
};

var queryCount = exports.queryCount = function queryCount(queriesState, queryConfig) {
    if (queryConfig) {
        var queryKey = (0, _queryKey.getQueryKey)(queryConfig);

        return (0, _lodash2.default)(queriesState, [queryKey, 'queryCount']);
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-query/dist/commonjs/selectors/query.js
 ** module id = 336
 ** module chunks = 3
 **/